module.exports = __webpack_public_path__ + "img/certificate-2-1.0a515cfc.jpg";